module.exports = __webpack_public_path__ + "img/left_video3.ed747fcd.png";